// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__OQncB","form":"styles_form__2eCKq"};